export enum CollectionsActionTypes {
  BLOCK = 'BLOCK',
  PAUSE = 'PAUSE',
  UNBLOCK = 'UNBLOCK',
  UNPAUSE = 'UNPAUSE',
}

export enum CreditType {
  BnplFactoring = 'BNPL factoring',
  RegulatedCredit = 'regulated credit',
  UnregulatedCredit = 'unregulated credit',
}
